<svg xmlns="http://www.w3.org/2000/svg" width="92" height="88" viewBox="0 0 92 88">
    <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="#FFF"/>
            <stop offset="100%" stop-color="#FFF"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path fill="url(#a)" stroke="#D9DDDF" stroke-width="2.25" d="M1.125 1.125h89.75v85.75H1.125z"/>
        <path stroke="#000" stroke-linecap="square" stroke-width="2.5" d="M51.339 46.96V25.667a4.668 4.668 0 1 0-9.337 0V46.96a10.893 10.893 0 1 0 9.337 0z"/>
        <path stroke="#000" stroke-linecap="square" stroke-width="2.35" d="M42.5 38.5h3M42.5 46.5h3M42.5 29.5h3"/>
    </g>
</svg>
